import React from 'react';
import { ShareableQuote } from './ShareableQuote';

export const ScriptureQuote = ({ text, reference }) => {
  return (
    <div 
      data-testid="scripture-quote"
      className="my-12 py-8 px-6 md:px-10 bg-gradient-to-r from-cream-paper to-cream rounded-2xl border-l-4 border-gold animate-fade-in"
    >
      <div className="max-w-2xl mx-auto text-center relative">
        <div className="absolute top-0 right-0">
          <ShareableQuote quote={text} type="scripture" reference={reference} />
        </div>
        <svg 
          className="w-8 h-8 mx-auto mb-4 text-gold/60" 
          fill="currentColor" 
          viewBox="0 0 24 24"
        >
          <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
        </svg>
        <p className="font-heading text-xl md:text-2xl italic text-charcoal leading-relaxed mb-4">
          "{text}"
        </p>
        <p className="text-gold font-medium text-sm md:text-base">
          — {reference}
        </p>
      </div>
    </div>
  );
};
